import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';
import type { createOrgRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { CreateOrgPageContainer } from './CreateOrgPageContainer';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof createOrgRoute>) {
  const { user } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  if (!user)
    return idealistRedirect({ request })(
      SIGN_UP_TO_POST_URL_FOR_LOCALE[context.locale],
    );
}

export default function OrgDashboardCreateOrgHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <CreateOrgPageContainer />;
}
